/**
 * Feature flags — gate Should/Could-Have surfaces so the demo can be tuned per
 * audience (TDD §12). All flags default ON; set the matching NEXT_PUBLIC_* env
 * var to "false" (or "0") to disable. NEXT_PUBLIC_* values are inlined at build
 * time, so changing a flag requires a rebuild.
 */
const flag = (v: string | undefined, def = true): boolean => {
  if (v === undefined || v === '') return def
  return v.toLowerCase() !== 'false' && v !== '0'
}

export const features = {
  /** In-app notification center (bell). */
  notifications: flag(process.env.NEXT_PUBLIC_ENABLE_NOTIFICATIONS),
  /** Enhanced Due Diligence consent workflow (AIP-10) surfaces. */
  consent: flag(process.env.NEXT_PUBLIC_ENABLE_CONSENT),
  /** CSV audit-trail export button. */
  csvExport: flag(process.env.NEXT_PUBLIC_ENABLE_CSV_EXPORT),
  /** Learning-from-exceptions insight surfaces. */
  insightsLearning: flag(process.env.NEXT_PUBLIC_ENABLE_INSIGHTS_LEARNING),
  /** Role-based Dashboard views (Compliance / RM / Ops). */
  roleViews: flag(process.env.NEXT_PUBLIC_ENABLE_ROLE_VIEWS),
  /** All-cases browser (gap G12) — view every case/document, not only exceptions. */
  casesBrowser: flag(process.env.NEXT_PUBLIC_ENABLE_CASES_BROWSER),
} as const
